import { useState, useCallback } from 'react'
import toast from 'react-hot-toast'

export const useAppointmentCheck = () => {
  const [isCheckingAppointment, setIsCheckingAppointment] = useState(false)
  const [hasExistingAppointment, setHasExistingAppointment] = useState(false)

  const checkExistingAppointment = useCallback(async () => {
    setIsCheckingAppointment(true)
    try {
      // Skip automatic appointment checking to avoid unnecessary API calls
      // User can still schedule appointments normally
      setHasExistingAppointment(false)
    } catch (error) {
      console.error('Error checking existing appointments:', error)
      // Don't show error, continue with normal flow
    } finally {
      setIsCheckingAppointment(false)
    }
  }, [])

  const checkAppointmentAndProceed = useCallback(async (userEmail: string, primaryAddress: string, onComplete?: (data: any) => Promise<void>) => {
    try {
      // Skip automatic appointment verification after Calendly return
      // Let the user proceed with the normal flow
      toast('Proceso de agendamiento completado. Continuando con el siguiente paso.', { icon: '✅' })
      
      if (onComplete) {
        await onComplete({
          completedAt: new Date().toISOString(),
          data: {
            appointmentType: 'visita_ocular', // Default fallback
            contactEmail: userEmail,
            location: primaryAddress,
            status: 'scheduled',
            source: 'calendly',
          },
        })
      }
    } catch (error) {
      console.error('Error in appointment flow:', error)
      toast.error('Error en el flujo de agendamiento')
    }
  }, [])

  return {
    isCheckingAppointment,
    hasExistingAppointment,
    checkExistingAppointment,
    checkAppointmentAndProceed
  }
}